// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueMaterial from 'vue-material';
import VueEvents from 'vue-events';
import 'vue-material/dist/vue-material.css';

import Debug from './plugins/debug/debug';
import GoogleDrive from './plugins/google_drive/google_drive';

import App from './App';

Vue.config.productionTip = false;

Vue.use(VueMaterial);
Vue.use(VueEvents);
Vue.use(Debug, { debug: true });
Vue.use(GoogleDrive, {
  client_id: '68467411263-ukrdou4cvadnak2r0pe1f4nosvjfm6np.apps.googleusercontent.com',
});

Vue.material.registerTheme('default', {
  accent: 'teal',
  warn: 'red',
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js